/* eslint-disable react/self-closing-comp */
import { h, Component } from 'preact';
import xhr from 'xhr';
import { jsxIf } from '../utils/jsx.util';
import checkDeviceType from '../helpers/checkDeviceType';
import { lockBodyPos } from '../helpers/bodyScroll';
import { floodlightsTrackLead } from '../pixels/floodlights/track_lead';

export default class NMLoginButton extends Component {
  constructor() {
    super();
    this.state = {
      windowOpen: true,
      iframesLoading: false,
    };
  }

  componentDidMount() {
    xhr({
      method: 'GET',
      uri: '<%=userLogoutUrls%>',
    }, (err, resp, body) => {
      this.setState({ userLogoutUrls: JSON.parse(body) });
    });
  }

  // If the user is logged into any other NM services, clicking the login button will log them out.
  LogoutFrames = () => {
    const nmisLogout = this.state.userLogoutUrls.nmisLogoutUrl;
    const urls = Object.values(this.state.userLogoutUrls.urls);
    const randomizeUrl = `?${Math.floor(Math.random() * 100000000)}${Math.floor(Math.random() * 100000000)}`;
    const iframeTitle = 'Logout Window Content';
    urls.forEach((key, i) => {
      urls[i] += randomizeUrl;
    });

    return (
      <div className='login-iframe-container'>
        {urls.map(url => (
          <iframe src={url} title={iframeTitle} />
        ))}
        <iframe src={nmisLogout} title={iframeTitle} />
      </div>
    );
  };

  openMenu = () => {
    lockBodyPos();
    this.setState({ iframesLoading: true });
    document.querySelector('.nm-user-login').classList.add('is-active');
    const device = checkDeviceType();
    if (device !== 'touchscreen') {
      document.querySelector('.js-input-first-focus-target').focus();
    }

    // Google analytics tracking
    gtag('event', 'send', {
      send_to: '<%=googleAnalyticsTrackingId%>',
      event_category: 'Log in Link',
      event_action: 'Click',
      event_label: 'Log in Link Click',
    });
    // BING tracking
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'LoginClick', {
      event_category: 'Click',
      event_label: 'LoginButton',
      event_value: '0',
    });
    // floodlights
    floodlightsTrackLead('finance/north004+unique');
  }

  render() {
    return (
      <div class='nm-login-button'>
        <button class='login-button nmx-button nmx-button--secondary' id='nm-login-button' aria-label='Open login menu' onClick={this.openMenu}>
          <img class='login-icon' src='<%=templateBasePath%>/images/user-login/login-profile-icon.svg' alt='user login profile icon' />
          Log in</button>
        {jsxIf(this.state.iframesLoading, () => (
          <div>{this.LogoutFrames()}</div>
        ))}
      </div>
    );
  }
}
